import { render } from "./RetailHome.vue?vue&type=template&id=38cd5636&scoped=true"
import script from "./RetailHome.vue?vue&type=script&lang=js"
export * from "./RetailHome.vue?vue&type=script&lang=js"

import "./RetailHome.vue?vue&type=style&index=0&id=38cd5636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd5636"]])

export default __exports__